import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { CloseOutlined } from '@ant-design/icons'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { InputNumber, Select, Button } from 'hljd'
import Store from './store'
import style from './style.module.less'

const Item = Form.Item
const Option = Select.Option
@Form.create()
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.form)
  }
  componentDidMount() {
    const { key, value } = this.props.data
    this.store.init(key, value)
  }
  render() {
    const { selectInputValue, addInput, deleteLastValue } = this.store
    const {
      text,
      options,
      placeholder,
      addButton,
      required,
      key
    } = this.props.data
    const { getFieldDecorator } = this.props.form
    return (
      <>
        {required ? (
          <p className={style.label}>{text}</p>
        ) : (
          <p className={style.labelCommon}>{text}</p>
        )}

        {selectInputValue.value.map((item, index) => {
          return (
            <div className={style.content} key={index}>
              <Item>
                {getFieldDecorator(`${key}-${index}-id`, {
                  initialValue: item.id ? item.id + '' : undefined,
                  rules: [{ required, message: `${text}信息未填写` }]
                })(
                  <Select className={style.area} placeholder={placeholder}>
                    {options.map(({ title, id }, index) => (
                      <Option key={id} value={id + ''}>
                        {title}
                      </Option>
                    ))}
                  </Select>
                )}
              </Item>
              <Item>
                {getFieldDecorator(`${key}-${index}-extra`, {
                  initialValue: item.extra,
                  rules: [{ required, message: `${text}信息未填写` }]
                })(
                  <InputNumber
                    min={0}
                    placeholder={'数量'}
                    className={style.area}
                    precision={0}
                  />
                )}
              </Item>
              {index === selectInputValue.value.length - 1 && (
                <CloseOutlined
                  className={style.deleteBtn}
                  onClick={deleteLastValue}
                />
              )}
            </div>
          )
        })}
        <Button onClick={addInput}>{addButton}</Button>
      </>
    )
  }
}
